import React from 'react';

import { store } from '@src/store';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { RouterWrapper } from './routes';

import '@styles/verktoy.scss';
import '@styles/entryPage.scss';
import '@styles/verktoyDetails.scss';

const renderApp = (): void => {
  const anchor: Element | null = document.getElementById('main-content-wrapper');

  if (anchor) {
    const root = createRoot(anchor);

    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <RouterWrapper />
        </Provider>
      </React.StrictMode>
    );
  }
};

if (import.meta.env.MODE === 'mocks') {
  import('./mocks/browser')
    .then(({ worker }) =>
      worker.start({
        onUnhandledRequest: 'bypass',
      })
    )
    .then(() => renderApp());
} else {
  renderApp();
}
